export default {
  RequestType: "Loại đề xuất",
  PU_INPUT_FORM_CONFIG_TITLE: "Trường thông tin",
  PU_INPUT_FORM_CONFIG_INPUTNAME: "Tên trường",
  PU_INPUT_FORM_CONFIG_SELECT_DATA: "Giá trị",
  PU_INPUT_FORM_CONFIG_SELECT_ADD_DATA: "Thêm dòng",
  PU_INPUT_FORM_CONFIG_SELECT_DATA_DEFAULT: "Giá trị ngầm định",
  PU_INPUT_FORM_CONFIG_SHOW_DESCRIPTION: "Hiển thị hướng dẫn",
  PU_INPUT_FORM_CONFIG_SHOW_DESCRIPTION_PLACEHOLDER: "Nhập nội dung hướng dẫn",
  PU_INPUT_FORM_CONFIG_IS_REQUIRED: "Là trường bắt buộc",
  PU_FORM_CONFIG_TYPE_SINGLE_LINE: "Một dòng",
  PU_FORM_CONFIG_TYPE_LETTER: "Chữ",
  PU_FORM_CONFIG_TYPE_MULTI_LINE: "Nhiều dòng",
  PU_FORM_CONFIG_TYPE_SINGLE_SELECT: "Chọn một",
  PU_FORM_CONFIG_TYPE_MULTI_SELECT: "Chọn nhiều",
  PU_FORM_CONFIG_TYPE_DATE: "Ngày tháng",
  PU_FORM_CONFIG_TYPE_DATETIME: "Ngày giờ",
  PU_FORM_CONFIG_TYPE_NUMBER: "Số",
  PU_FORM_CONFIG_TYPE_DECIMAL: "Số thập phân",
  PU_FORM_CONFIG_TYPE_CHECKBOX: "Tích chọn",
  PU_FORM_CONFIG_TYPE_ORGANIZATION: "Tổ chức",
  PU_FORM_CONFIG_TYPE_EMPLOYEE: "Nhân viên",
  PU_FORM_CONFIG_TYPE_UPLOAD_IMAGE: "Tải ảnh",
  PU_FORM_CONFIG_TYPE_UPLOAD_FILE: "Tải tệp",
  PU_FORM_CONFIG_TYPE_SELECT_PERSON: "Chọn người",
};
